import { FadeIn } from "./common";
import CategoryHeader from "./CategoryHeader";
import { CategoryBackground } from "./SciBackground";
import { Search, Workflow, Plug, TrendingUp } from "lucide-react";

const PILLARS = [
  {
    icon: Search,
    title: "Investigate",
    text: "Scientific root-cause analysis of manufacturing and analytical failures — evidence before conclusions.",
  },
  {
    icon: Workflow,
    title: "Automate",
    text: "Replace repetitive manual data work with scalable, reliable digital workflows.",
  },
  {
    icon: Plug,
    title: "Connect",
    text: "Bring disconnected manufacturing data sources into unified analytical datasets.",
  },
  {
    icon: TrendingUp,
    title: "Improve",
    text: "Translate evidence into CAPA, process improvement, specification review and sustained operational decisions.",
  },
];

export default function Pillars() {
  return (
    <section className="relative overflow-hidden" data-testid="pillars-section">
      <CategoryBackground variant="pillars" accent="teal" accent2="cyan" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 pb-20">
      <CategoryHeader
        eyebrow="Core Value Proposition"
        title="One workflow: problem to sustained improvement"
        description="Manufacturing problems are solved end-to-end — investigated scientifically, made measurable with data, scaled with automation, and held in place with Quality-controlled change."
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 mt-10 border border-cyan/15 rounded-md overflow-hidden">
        {PILLARS.map((p, i) => {
          const Icon = p.icon;
          return (
            <FadeIn key={p.title} delay={i * 0.08} className="h-full">
              <div
                className="group h-full p-6 lg:p-8 bg-navy2 border-b sm:border-b-0 sm:border-r last:border-r-0 border-cyan/15 hover:bg-teal/10 transition-colors"
                data-testid={`pillar-${p.title.toLowerCase()}`}
              >
                <div className="flex items-center justify-between">
                  <Icon className="w-6 h-6 text-cyan" aria-hidden="true" />
                  <span className="font-mono text-[10px] text-steel">0{i + 1}</span>
                </div>
                <h3 className="font-sans text-lg font-semibold tracking-tight text-paper mt-6 uppercase">{p.title}</h3>
                <p className="text-sm text-steel mt-3 leading-relaxed">{p.text}</p>
                <div className="mt-6 h-px w-8 bg-teal/50 group-hover:w-full group-hover:bg-cyan/60 transition-all duration-500" aria-hidden="true" />
              </div>
            </FadeIn>
          );
        })}
      </div>
      </div>
    </section>
  );
}
